import { get } from 'lodash';
import { Service } from '@zapier/services/esm/types';

export default function isServiceHidden(service: Service) {
  return service.isHidden || get(service, 'hidden');
}
